import { Home } from "@mui/icons-material";
import {
	FormControl,
	FormHelperText,
	FormLabel,
	TextField,
	Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ErrorMessage, FormikProvider, useFormik } from "formik";
import { useTranslation } from "react-i18next";
import {useHistory, useParams} from "react-router-dom";
import * as yup from "yup";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import { PAGE_LOGIN } from "../../../../locales/pages/namespaces";
import {ROUTE_PAGE_HOME, ROUTE_PAGE_INITIAL} from "../../../../routers/routes";
import axios from "axios";
import {getEndPoint} from "../../../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../../../helpers/errorHandling";
import {useState} from "react";
import {LoadingButton} from "@mui/lab";
import {useUser} from "../../../../userContext/userContext";



const whiteInputProps = {
	variant: "standard",
	InputProps: {
		disableUnderline: true,
		sx: {
			color: "#fff",
			fontSize: 15,
			borderBottom: "1px solid rgba(255,255,255,0.8)",
			pb: 0.5,

			"& input": {
				color: "#fff !important",
			},

			"& input::placeholder": {
				color: "rgba(255,255,255,0.6)",
			},

			"&:hover": {
				borderBottom: "1px solid #fff",
			},
		},
	},
};

const Form = () => {
	const {campaign} = useParams()
	const { t } = useTranslation(PAGE_LOGIN);
	const history = useHistory();
	const [loading,setLoading] = useState(false)
	const {setChangePassId,setChangePassMail} = useUser()
	function onSubmit(values) {
		setLoading(true)
		axios({
			method: 'post',
			url: getEndPoint('changePassword'),
			data: values,
			headers: { 'Content-Type': 'application/json' },
		})
			.then((response) => {
				const changeId = response.data.DATABASE.id
				const changeMail = response.data.DATABASE.email
				console.log('changeId in submit',changeId)
				setChangePassId(changeId)
				setChangePassMail(changeMail)
				setLoading(false)
				history.push(getRouteUrl(ROUTE_PAGE_INITIAL, { campaign }));
			})
			.catch((error) => {
				enqueueSnackbar(t("Wrong password or email"), {
					variant: 'error',
				});
				setLoading(false)
			});
	}

	const validationSchema = yup.object({
		email: yup.string().email(t("Invalid email")).required(t("Required")),
	});

	const formik = useFormik({
		initialValues: { email: "" },
		validationSchema,
		onSubmit:onSubmit
	});

	return (
		<FormikProvider value={formik}>
			<Box
				component="form"
				onSubmit={formik.handleSubmit}
				noValidate
				sx={{
					padding: {
						xs: "10px 20px",
						sm: "20px 40px",
						md: "40px",
					},
				}}
			>
				<Box width="100%">
					{/* EMAIL FIELD */}
					<FormControl fullWidth sx={{ mb: 3 }}>
						<FormLabel sx={{ color: "#fff", fontSize: 14, mb: 1 }} required>
							{t("Email")}
						</FormLabel>

						<TextField
							{...whiteInputProps}
							name="email"
							value={formik.values.email}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder={t("Enter your email")}
							required
						/>

						<FormHelperText sx={{ color: "#ffd1d1" }}>
							<ErrorMessage name="email" />
						</FormHelperText>
					</FormControl>

					<LoadingButton
						loading={loading}
						fullWidth
						variant="contained"
						type="submit"
						sx={{
							background: "#fff",
							color: "#004B88",
							mt: 2,
							py: 1.4,
							borderRadius: "3px",
							fontWeight: 700,
							textTransform: "none",
							"&:hover": { background: "#e6e6e6" },
						}}
					>
						{t("Continue")}
					</LoadingButton>

					<Button
						fullWidth
						variant="outlined"
						startIcon={<Home />}
						sx={{
							mt: 2,
							py: 1.4,
							textTransform: "none",
							borderColor: "rgba(255,255,255,0.7)",
							color: "#fff",
							"&:hover": {
								borderColor: "#fff",
								background: "rgba(255,255,255,0.1)",
							},
						}}
						onClick={() => history.push(getRouteUrl(ROUTE_PAGE_HOME,{campaign}))}
					>
						{t("Home")}
					</Button>
				</Box>
			</Box>
		</FormikProvider>
	);
};

export default Form;
